import * as React from 'react';
import * as moment from 'moment';
import { getProspectsDetails, getTourlessProspectInfo, Prospect, ProspectInfo, ProspectTourInfo } from '../../../../api/Prospect';
import { ApiResult } from '../../../../api/Shared';
import { useFetch } from '../../../../hooks/useFetch';
import { RecentActivityWidget } from './recentActivity';
import { TourStatuses } from '../../../../utilities/Enums';
import { Property } from '../../../../api/Property';
import { momentDateFormat } from '../../../../utilities/formatting';

interface Props {
    selectedProperty: Property | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    excludedProspects: Prospect[];
    setExcludedProspects: (value: Prospect[]) => void;
}

const RecentActivityContainer = ({
    selectedProperty,
    startDate,
    endDate,
    excludedProspects,
    setExcludedProspects
}: Props) => {
    const selectedPropertyId = (selectedProperty && selectedProperty.id) || null;

    //prospects
    const fetchFunction = selectedPropertyId
        ? () =>
            getProspectsDetails({
                  endDate: endDate.clone().add(1, 'day').format(momentDateFormat),
                  propertyIds: [selectedPropertyId],
                  startDate: startDate.format(momentDateFormat),
              })
        : () =>
              new Promise<ApiResult<ProspectInfo[]>>(resolve =>
                  resolve({ success: false, error: 'No propertyId selected', data: [] })
              );
        
    const {
        data: prospects,
        loading: prospectLoading,
        setData: setProspects
    } = useFetch(fetchFunction, [selectedPropertyId, startDate, endDate], [] as ProspectInfo[]);


    const fetchTourlessFunction = selectedPropertyId
        ? () => getTourlessProspectInfo([selectedPropertyId], startDate, endDate.clone().add(1, 'day'))
        : () =>
              new Promise<ApiResult<ProspectTourInfo[]>>(resolve =>
                  resolve({ success: false, error: 'No propertyId selected', data: [] })
              );

    const { data: tourProspects, loading: tourlessLoading } = useFetch(
        fetchTourlessFunction,
        [selectedPropertyId, startDate, endDate, excludedProspects],
        [] as ProspectTourInfo[]
    );

    return (
        <RecentActivityWidget
            prospects={prospects || []}
            tourProspects={tourProspects || []}
            loading={prospectLoading || tourlessLoading}
            startDate={startDate}
            endDate={endDate}
            propertyId={selectedPropertyId}
            property={selectedProperty}
            updateSelectedProspect={(newProspect: Prospect, cancelled: boolean) => {
                let tempProspects = prospects;
                if (cancelled) {
                    newProspect.tourInfo.status = TourStatuses.Cancelled;
                }
                // let updatedProspectIndex = tempProspects.findIndex(
                //     p => p.publicKey === newProspect.publicKey
                // );
                // tempProspects[updatedProspectIndex] = newProspect;

                setProspects(tempProspects);
            }}
            addExcludedProspect={(prospect: Prospect) =>
                setExcludedProspects(excludedProspects.concat([prospect]))
            }
        />
    );
};

export default RecentActivityContainer;



// WEBPACK FOOTER //
// ./src/components/pages/admin/dashboardWidgets/RecentActivityContainer.tsx